import { makeRequestAuth } from "../utils/globals";

class ReportService {
  /* 
    ==========================================================================================================================
    ==========================================================================================================================
    ==========================================================================================================================
                                    COMMON REPORTS SERVICE
    ==========================================================================================================================
    ==========================================================================================================================
    ==========================================================================================================================
    */

  /*
   * @Description : cancel voucher code
   * @input : voucher id
   * @returns{promise}
   */
  xoxoVoucherCodeCancel = (voucher_id, reason) => {
    const base64regex =
      /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
    let id = !base64regex.test(voucher_id) ? voucher_id : atob(voucher_id);
    return new Promise((resolve, reject) => {
      const queryData = {
        query: "storesAdmin.mutation.xoxoVoucherCodeCancel",
        tag: "storeAdmin",
        variables: {
          voucher_id: id,
          reason: reason,
        },
      };
      makeRequestAuth(queryData, (response) => {
        if (
          response &&
          response.data &&
          response.data.xoxoVoucherCodeCancel &&
          response.data.xoxoVoucherCodeCancel.output
        ) {
          resolve(response.data.xoxoVoucherCodeCancel.output);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  /*
   * @Description : cancel xoxo point
   * @input : voucher id
   * @returns{promise}
   */
  xoxoPointCancel = (voucher_id, reason) => {
    const base64regex =
      /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
    let id = !base64regex.test(voucher_id) ? voucher_id : atob(voucher_id);
    return new Promise((resolve, reject) => {
      const queryData = {
        query: "storesAdmin.mutation.xoxoPointCancel",
        tag: "storeAdmin",
        variables: {
          voucher_id: id,
          reason: reason,
        },
      };
      makeRequestAuth(queryData, (response) => {
        if (
          response &&
          response.data &&
          response.data.xoxoPointCancel &&
          response.data.xoxoPointCancel.output
        ) {
          resolve(response.data.xoxoPointCancel.output);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  /*
   * @Description : cancel xoxo point
   * @input : voucher id
   * @returns{promise}
   */
  xoxoPointResend = (voucher_id) => {
    const base64regex =
      /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
    let id = !base64regex.test(voucher_id) ? voucher_id : atob(voucher_id);
    return new Promise((resolve, reject) => {
      const queryData = {
        query: "storesAdmin.mutation.xoxoPointResend",
        tag: "storeAdmin",
        variables: {
          voucher_id: id,
        },
      };
      makeRequestAuth(queryData, (response) => {
        if (
          response &&
          response.data &&
          response.data.xoxoPointResend &&
          response.data.xoxoPointResend.output
        ) {
          resolve(response.data.xoxoPointResend.output);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  /*
   * @Description : get plum payments report
   * @returns{promise}
   */
  plumReportSearch = (addData) => {
    return new Promise((resolve, reject) => {
      const plumReportSearch = {
        query: "storesAdmin.query.plumReportSearch",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(plumReportSearch, (response) => {
        if (
          response &&
          response.data &&
          response.data.plumReportSearch &&
          response.data.plumReportSearch.success
        ) {
          resolve(response.data.plumReportSearch);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  /*
   * @Description : get list of all admin
   * @returns{promise}
   */
  getAdminList = (params) => {
    return new Promise((resolve, reject) => {
      const getAdminList = {
        query: "storesAdmin.query.getAdminList",
        tag: "storeAdmin",
        variables: {
          add_data: {
            ...params,
          },
        },
      };
      makeRequestAuth(getAdminList, (response) => {
        if (
          response &&
          response.data &&
          response.data.getAdminList &&
          response.data.getAdminList.success
        ) {
          resolve(response.data.getAdminList);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  /*
   * @Description : sends email for voucher id
   * @returns{promise}
   */
  plumReportGetCsv = (addData) => {
    return new Promise((resolve, reject) => {
      const plumReportGetCsv = {
        query: "storesAdmin.query.plumReportGetCsv",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(plumReportGetCsv, (response) => {
        if (response && response.data && response.data.plumReportGetCsv) {
          resolve(response.data.plumReportGetCsv);
        } else {
          reject(new Error("Api Error"));
        }
      });
    });
  };

  /*
   * @Description : sends email for voucher id
   * @returns{promise}
   */
  plumResendVoucher = (addData) => {
    return new Promise((resolve, reject) => {
      const plumResendVoucher = {
        query: "storesAdmin.mutation.resendGiftCardCode",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(plumResendVoucher, (response) => {
        if (response && response.data && response.data.resendGiftCardCode) {
          resolve(response.data.resendGiftCardCode);
        } else {
          reject(new Error("Api Error"));
        }
      });
    });
  };

  /*
   * @Description : get list of all admin
   * @returns{promise}
   */
  getReportMultiAdminList = (params) => {
    return new Promise((resolve, reject) => {
      const getAdminList = {
        query: "storesAdmin.query.getReportMultiAdminList",
        tag: "storeAdmin",
        variables: {
          add_data: {
            ...params,
          },
        },
      };
      makeRequestAuth(getAdminList, (response) => {
        if (
          response &&
          response.data &&
          response.data.getReportMultiAdminList &&
          response.data.getReportMultiAdminList.success
        ) {
          resolve(response.data.getReportMultiAdminList);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  /*
   * @Description : add filter to saved filter
   * @returns{promise}
   */
  addReportFilter = (params, reward_type) => {
    return new Promise((resolve, reject) => {
      const addRpFilter = {
        query: "storesAdmin.mutation.addRpFilter",
        tag: "storeAdmin",
        variables: {
          add_data: params,
          reward_type: reward_type,
        },
      };
      makeRequestAuth(addRpFilter, (response) => {
        if (response && response.data && response.data.addRpFilter) {
          resolve(response.data.addRpFilter);
        } else {
          resolve({ message: ["Something went wrong"], error: true });
        }
      });
    });
  };

  /*
   * @Description : fetch saved filter
   * @returns{promise}
   */
  getSavedFilter = (reward_type) => {
    return new Promise((resolve, reject) => {
      const getSavedFilter = {
        query: "storesAdmin.mutation.getSavedFilter",
        tag: "storeAdmin",
        variables: {
          reward_type: reward_type,
        },
      };
      makeRequestAuth(getSavedFilter, (response) => {
        if (response && response.data && response.data.getSavedFilter) {
          resolve(response.data.getSavedFilter);
        } else {
          resolve({ message: ["Something went wrong"], error: true });
        }
      });
    });
  };

  /*
   * @Description : fetch saved filter
   * @returns{promise}
   */
  deleteSavedFilter = (reward_type, filter_id) => {
    return new Promise((resolve, reject) => {
      const deleteSavedFilter = {
        query: "storesAdmin.mutation.deleteSavedFilter",
        tag: "storeAdmin",
        variables: {
          reward_type: reward_type,
          filter_id: filter_id,
        },
      };
      makeRequestAuth(deleteSavedFilter, (response) => {
        if (response && response.data && response.data.deleteSavedFilter) {
          resolve(response.data.deleteSavedFilter);
        } else {
          resolve({ message: ["Something went wrong"], error: true });
        }
      });
    });
  };

  /*
   * @Description : fetch saved filter
   * @returns{promise}
   */
  bulkCancelReward = (sendData, reason_for_cancellation) => {
    return new Promise((resolve, reject) => {
      const bulkCancelRewards = {
        query: "storesAdmin.mutation.bulkCancelRewards",
        tag: "storeAdmin",
        variables: {
          ...sendData,
          reason: reason_for_cancellation,
        },
      };
      makeRequestAuth(bulkCancelRewards, (response) => {
        if (response && response.data && response.data.bulkCancelRewards) {
          resolve(response.data.bulkCancelRewards);
        } else {
          resolve({ message: ["Something went wrong"], error: true });
        }
      });
    });
  };

  /*
   * @Description : fetch saved filter
   * @returns{promise}
   */
  bulkResendRewards = (sendData) => {
    return new Promise((resolve, reject) => {
      const bulkResenRewards = {
        query: "storesAdmin.mutation.bulkResendRewards",
        tag: "storeAdmin",
        variables: {
          ...sendData,
        },
      };
      makeRequestAuth(bulkResenRewards, (response) => {
        if (response && response.data && response.data.bulkResendRewards) {
          resolve(response.data.bulkResendRewards);
        } else {
          resolve({ message: ["Something went wrong"], error: true });
        }
      });
    });
  };

  /* 
    ==========================================================================================================================
    ==========================================================================================================================
    ==========================================================================================================================
                                    NON MUTLIADMIN REPORTS SERVICE
    ==========================================================================================================================
    ==========================================================================================================================
    ==========================================================================================================================
    */

  /*
   * @Description : get plum points report
   * @returns{promise}
   */
  plumPointReport = (addData) => {
    return new Promise((resolve, reject) => {
      const PlumPointsReport = {
        query: "storesAdmin.query.getPlumPointsReport",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(PlumPointsReport, (response) => {
        if (response && response.data) {
          resolve(response);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  /*
   * @Description : get plum voucher report
   * @returns{promise}
   */
  plumVoucherReport = (addData, signal = false) => {
    return new Promise((resolve, reject) => {
      const PlumVoucherReport = {
        query: "storesAdmin.query.getPlumVoucherReport",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(
        PlumVoucherReport,
        (response) => {
          if (response) {
            resolve(response);
          } else {
            resolve({ Message: "Something went wrong", success: 0 });
          }
        },
        "",
        "",
        signal
      );
    });
  };

  /*
   * @Description : get plum payments report
   * @returns{promise}
   */
  plumPaymentsReport = (addData) => {
    return new Promise((resolve, reject) => {
      const PlumPaymentReport = {
        query: "storesAdmin.query.getPlumPaymentReport",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(PlumPaymentReport, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  /* 
    ==========================================================================================================================
    ==========================================================================================================================
    ==========================================================================================================================
                                        MUTLIADMIN REPORTS SERVICE
    ==========================================================================================================================
    ==========================================================================================================================
    ==========================================================================================================================
    */

  /*
   * @Description : get plum points report
   * @returns{promise}
   */
  multiAdminPointReport = (addData, signal = false) => {
    return new Promise((resolve, reject) => {
      const PlumPointsReport = {
        query: "storesAdmin.query.getMultiAdminPointsReport",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(
        PlumPointsReport,
        (response) => {
          if (response && response.data) {
            resolve(response);
          } else {
            resolve({ Message: "Something went wrong", success: 0 });
          }
        },
        "",
        "",
        signal
      );
    });
  };

  /*
   * @Description : get plum points TOTAL POINTS SENT TOTAL POINTS REDEEMED
   * @returns{promise}
   */
  getPlumMultiAdminPointsCount = (addData) => {
    return new Promise((resolve, reject) => {
      const plummultiadminpointscount = {
        query: "storesAdmin.query.getPlumMultiAdminPointsCount",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(plummultiadminpointscount, (response) => {
        if (response && response.data) {
          resolve(response);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  /*
   * @Description : get plum voucher report
   * @returns{promise}
   */
  multiAdminVoucherReport = (addData, signal = false) => {
    return new Promise((resolve, reject) => {
      const PlumVoucherReport = {
        query: "storesAdmin.query.getMultiAdminVoucherReport",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(
        PlumVoucherReport,
        (response) => {
          if (response) {
            resolve(response);
          } else {
            resolve({ Message: "Something went wrong", success: 0 });
          }
        },
        "",
        "",
        signal
      );
    });
  };
  /*
   * @Description : get plum code TOTAL POINTS SENT TOTAL POINTS REDEEMED
   * @returns{promise}
   */
  getPlumMultiAdminVoucherCount = (addData) => {
    return new Promise((resolve, reject) => {
      const plummultiadminvouchercount = {
        query: "storesAdmin.query.getPlumMultiAdminVoucherCount",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(plummultiadminvouchercount, (response) => {
        if (response && response.data) {
          resolve(response);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  /*
   * @Description : get plum payments report
   * @returns{promise}
   */
  multiAdminPaymentsReport = (addData, signal = false) => {
    return new Promise((resolve, reject) => {
      const PlumPaymentReport = {
        query: "storesAdmin.query.getMultiAdminPaymentReport",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(
        PlumPaymentReport,
        (response) => {
          if (response) {
            resolve(response);
          } else {
            resolve({ Message: "Something went wrong", success: 0 });
          }
        },
        "",
        "",
        signal
      );
    });
  };

  empulsPaymentsReport = (addData) => {
    return new Promise((resolve, reject) => {
      const empulsPaymentReport = {
        query: "storesAdmin.query.plumProRechargeHistory",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(empulsPaymentReport, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  plumProRechargeHistory = (addData) => {
    return new Promise((resolve, reject) => {
      const plumProRechargeHistory = {
        query: "storesAdmin.query.plumProRechargeHistory",
        tag: "storeAdmin",
        variables: {
          add_data: {
            ...addData,
            client_dashboard_recharge: 1,
            company_recharge: 0,
            superadmin_recharge: 0,
          },
        },
      };
      makeRequestAuth(plumProRechargeHistory, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  // Empuls Report
  redemptionHistoryReport = (addData) => {
    return new Promise((resolve, reject) => {
      const empulsPaymentReport = {
        query: "storesAdmin.query.CompanyFundRedReport",
        tag: "storeAdmin",
        variables: {
          cfrh_data: addData,
        },
      };
      makeRequestAuth(empulsPaymentReport, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };
  companyFundRedemptionOrderDetails = (addData) => {
    return new Promise((resolve, reject) => {
      const empulsPaymentReport = {
        query: "storesAdmin.query.companyFundRedemptionOrderDetails",
        tag: "storeAdmin",
        variables: {
          cfrh_data: addData,
        },
      };
      makeRequestAuth(empulsPaymentReport, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  /* 
    ==========================================================================================================================
    ==========================================================================================================================
    ==========================================================================================================================
                                    E1 Migrated Company Report
    ==========================================================================================================================
    ==========================================================================================================================
    ==========================================================================================================================
    */

  /*
   * @Description :
   * @returns{promise}
   */
  e1PointsRecharge = (cid) => {
    return new Promise((resolve, reject) => {
      const e1PointsRecharge = {
        query: "storesAdmin.query.e1PointsRecharge",
        tag: "storeAdmin",
        variables: {
          cd_data: { cid },
        },
      };
      makeRequestAuth(e1PointsRecharge, (response) => {
        if (response && response.data) {
          resolve(response);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  /*
   * @Description :
   * @returns{promise}
   */
  userPointSummary = (cid) => {
    return new Promise((resolve, reject) => {
      const userPointSummary = {
        query: "storesAdmin.query.userPointSummary",
        tag: "storeAdmin",
        variables: {
          cd_data: { cid },
        },
      };
      makeRequestAuth(userPointSummary, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  /*
   * @Description :
   * @returns{promise}
   */
  redemptionAndPayment = (cid) => {
    return new Promise((resolve, reject) => {
      const PlumPaymentReport = {
        query: "storesAdmin.query.redemptionAndPayment",
        tag: "storeAdmin",
        variables: {
          cd_data: { cid },
        },
      };
      makeRequestAuth(PlumPaymentReport, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  /* 
    ==========================================================================================================================
    ==========================================================================================================================
    ==========================================================================================================================
                                    Plum Pro report
    ==========================================================================================================================
    ==========================================================================================================================
    ==========================================================================================================================
    */

  /*
   * @Description :
   * @returns{promise}
   */
  plumProOrderReport = (params, signal = false) => {
    return new Promise((resolve, reject) => {
      const payload = {
        query: "storesAdmin.query.ClientDashboardReport",
        tag: "storeAdmin",
        variables: {
          cd_data: params,
        },
      };
      makeRequestAuth(
        payload,
        (response) => {
          if (response) {
            resolve(response);
          } else {
            resolve({ Message: "Something went wrong", success: 0 });
          }
        },
        "",
        "",
        signal
      );
    });
  };

  downloadPlumProReport = (params) => {
    return new Promise((resolve, reject) => {
      const payload = {
        query: "storesAdmin.query.downloadPlumProReport",
        tag: "storeAdmin",
        variables: {
          cd_data: params,
        },
      };
      makeRequestAuth(payload, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  resendPlumPlatformOrder = (add_data) => {
    return new Promise((resolve, reject) => {
      let payload = {
        query: "storesAdmin.mutation.resendVoucherAdmin",
        tag: "storeAdmin",
        variables: {
          add_data: { ...add_data },
        },
      };
      makeRequestAuth(payload, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  resendPlumProApiOrder = (add_data) => {
    return new Promise((resolve, reject) => {
      let payload = {
        query: "storesAdmin.mutation.resendPlumProApiOrder",
        tag: "storeAdmin",
        variables: {
          add_data: { ...add_data },
        },
      };
      makeRequestAuth(payload, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  /* 
    ==========================================================================================================================
    ==========================================================================================================================
    ==========================================================================================================================
                                    Xoxo Link Report
    ==========================================================================================================================
    ==========================================================================================================================
    ==========================================================================================================================
    */

  getXoxoLinkReportsTable = (sendData, signal = false) => {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.query.getxoxoLinkTable";
      const request_data = {
        query: query,
        tag: "storeAdmin",
        variables: {
          ...sendData,
        },
      };
      makeRequestAuth(
        request_data,
        (response) => {
          if (response) {
            resolve(response);
          } else {
            resolve({});
          }
        },
        "",
        "",
        signal
      );
    });
  };

  getXoxoLinkReportsDownload = (sendData) => {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.query.getxoxoDownloadLinkReports";
      const request_data = {
        query: query,
        tag: "storeAdmin",
        variables: {
          ...sendData,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve({});
        }
      });
    });
  };

  getXoxoLinkBatchReportDownload = async (sendData) => {
    return new Promise((resolve) => {
      const query = "storesAdmin.query.getXoxoLinkBatchReportDownload";
      const request_data = {
        query: query,
        tag: "storeAdmin",
        variables: {
          ...sendData,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve({});
        }
      });
    });
  };

  cancelSingleXoxoLinkLink = (batchId, reason) => {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.mutation.cancelSingleXoxoLink";
      const request_data = {
        query: query,
        tag: "storeAdmin",
        variables: {
          linkId: batchId,
          reason: reason,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve({});
        }
      });
    });
  };

  resendSingleXoxoLink = (batchId) => {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.mutation.resendSingleXoxoLink";
      const request_data = {
        query: query,
        tag: "storeAdmin",
        variables: {
          linkId: batchId,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve({});
        }
      });
    });
  };

  resendbulkXoxoLink = (batchId) => {
    return new Promise((resolve, reject) => {
      const query = "storesAdmin.query.emailBatchDetails";
      const request_data = {
        query: query,
        tag: "storeAdmin",
        variables: {
          add_data: {
            batchId: batchId,
          },
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response) {
          resolve(response);
        } else {
          resolve({});
        }
      });
    });
  };

  cancelBatch = (params) => {
    return new Promise((resolve, reject) => {
      const request_data = {
        query: "storesAdmin.mutation.cancelBatchLinks",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  getTotalReportCount = (addData) => {
    return new Promise((resolve, reject) => {
      const gettotalpointscount = {
        query: "storesAdmin.query.getTotalReportCount",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(gettotalpointscount, (response) => {
        if (response && response.data) {
          resolve(response);
        } else {
          resolve({ Message: "Something went wrong", success: 0, ...response });
        }
      });
    });
  };

  handleUrl = (fileUrl) => {
    const downloadData = {
      query: "stores.mutation.fileDownload",
      tag: "stores",
      variables: {
        add_data: fileUrl,
      },
    };
    makeRequestAuth(
      downloadData,
      function (resp) {
        if (
          resp &&
          resp.data &&
          resp.data.fileDownload &&
          resp.data.fileDownload.output
        ) {
          let response = JSON.parse(resp.data.fileDownload.output);
          let url = "data:" + response.type + ";base64," + response.data;
          var link = document.createElement("a");
          link.download = response && response.filename;
          link.href = url;
          link.click();
        }
      }.bind(this)
    );
  };

  fetchActivityTimeline = (addData) => {
    return new Promise((resolve, reject) => {
      const gettotalpointscount = {
        query: "storesAdmin.query.fetchActivityTimeline",
        tag: "storeAdmin",
        variables: {
          add_data: addData,
        },
      };
      makeRequestAuth(gettotalpointscount, (response) => {
        if (response && response.data) {
          resolve(response);
        } else {
          resolve({ Message: "Something went wrong", success: 0, ...response });
        }
      });
    });
  };


}

export default Object.freeze(new ReportService());
